import { motion } from "framer-motion";
import { LANDING } from "@/constants/testIds";

const STEPS = [
  {
    n: "01",
    title: "Connect Spotify",
    body: "One tap OAuth sign-in. We only read your now-playing track — nothing else.",
  },
  {
    n: "02",
    title: "Go live",
    body: "Drop your pin on the map. Your city sees what you're playing, in real time.",
  },
  {
    n: "03",
    title: "Explore & sync",
    body: "Tap any pin to see the track, radar a song in the air, or listen along together.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      className="relative bg-[#0a0414] py-28 sm:py-36 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-xl mb-20"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#a259ff] font-semibold">
            How it works
          </span>
          <h2
            data-testid={LANDING.howItWorksHeading}
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4 leading-tight"
          >
            Live in under a minute.
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-10 relative">
          <div className="hidden sm:block absolute top-9 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#a259ff]/40 to-transparent" />
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={LANDING.howItWorksStep(i)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
            >
              <div className="relative z-10 flex h-[72px] w-[72px] items-center justify-center rounded-2xl bg-[#0a0414] border border-[#a259ff]/30 font-display text-xl font-bold text-[#22d3ee] shadow-[0_0_30px_rgba(162,89,255,0.25)] mb-6">
                {s.n}
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-3">{s.title}</h3>
              <p className="text-[#b9a9e6] leading-relaxed max-w-xs">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
